import { NAVBAR } from 'composer-blocks/lib/constants/BlockTypes';
import * as contentTypes from 'composer-blocks/lib/constants/ContentTypes';

export default {
  id: 'navbar_22',
  type: NAVBAR,
  name: 'Navbar 22',
  thumbnail: 'https://eventtia-composer.s3.amazonaws.com/assets/images/thumbnails/navbar/navbar_22.png',
  rootContent: {
    type: contentTypes.NAVBAR,
    properties: {
      backgroundColor: {type: 'css', value: '#BBE88C',editable: true},
      color: {type: 'css', value: 'black', editable: true},
      borderTop: {type: 'css', value: '20px solid black', editable: true},
      padding: {type: 'css', value: '0.5rem 1rem'},
      fontSize: {type: 'css', value: 'small', editable: true},
      logoSrc: {type: 'custom', value: '', editable: true},
      logoHeight: {type: 'custom', value: '3.5rem'},
      navItemPadding: {type: 'custom', value: '0.5rem'},
      navItemMargin: {type: 'custom', value: '0rem 0.5rem'},
      navItemHoverBorder: {type: 'custom', value: '#000000'},
      navItemActiveBackground: {type: 'custom', value: '#000000'},
      navItemActiveTextColor: {type: 'custom', value: 'white'},
      fontWeight: {type: 'css', value: 'normal'},
      navListItemSeparator: {type: 'custom', value: 'true'},
      socialMedia: {type: 'custom', value: true, editable: true},
      facebookLink: {type: 'custom', value: 'facebook.com', editable: true},
      socialMediaIconColor: {type: 'custom', value: '#000000', editable: true}

    },
    contents: []
  }
}
